import { Injectable } from '@angular/core';
import { Account } from 'msal';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { UserInviteClient, EditUserInviteCommand, EmailInviteStatus } from '@services/cleanfill-api/cleanfill-api.generated';

@Injectable({ providedIn: 'root' })
export class StoreSignupService {
  constructor(private userInviteClient: UserInviteClient) {}

  inviteUser(randomKey: string) {
    const command = new EditUserInviteCommand();
    command.uniqueId = randomKey;
    command.status = EmailInviteStatus.Accepted;
    return this.userInviteClient.editUserInvite(undefined, command).toPromise();
  }
}
